// Copyright (c) Docugami, Inc. All rights reserved.
import { AnyAction } from "@reduxjs/toolkit";
import { OrganizationsState, SET_ORGANIZATION_LIST, SET_CURRENT_ORGANIZATION, CREATE_ORGANIZATION, SET_CREATE_ORGANIZATION_POLLING, ADD_PIPELINE_BUILD, REMOVE_PIPELINE_BUILD, SET_PIPELINE_BUILDS_STATE, UPDATE_ORGANIZATION, SET_USER_LIST, SET_ORGANIZATION_ACCOUNT } from "./types";

const initialState: OrganizationsState = {
    organizationList: {
        fetchState: {
            fetched: false,
            fetching: false,
        },
        indexed: {},
        allIds: []
    },
    creationState: {
        waiting: false,
        created: false,
        creating: false,
        unknown: true,
        statusUrl: '',
    },
    // @ts-ignore
    currentOrganization: null,
    createOrganizationPolling: false,
    onboardFilesBuilds: {
        fetchState: {
            fetched: false,
            fetching: false
        },
        activeBuilds: [],
        folderIndexed: {}
    },
    pipelineBuilds: {
        fetchState: {
            fetched: false,
            fetching: false
        },
        activeBuilds: []
    },
    signalR: {
        fetchState: {
            fetched: false,
            fetching: false,
        },
        // @ts-ignore
        connection: null
    },
    userList: null,
    organizationAccount: undefined
};

export function organizationReducer(
    state = initialState,
    action: AnyAction
): OrganizationsState {
    switch (action.type) {
        case SET_ORGANIZATION_LIST:
            {
                return { ...state, organizationList: action.payload };
            }

        case SET_CURRENT_ORGANIZATION:
            {
                return { ...state, currentOrganization: action.payload };
            }

        case UPDATE_ORGANIZATION:
            {
                let newState = { ...state };

                if (state.currentOrganization && state.currentOrganization.id === action.payload.id) {
                    newState.currentOrganization = { ...action.payload };
                }

                if (action.payload.id in newState.organizationList.indexed) {
                    newState.organizationList.indexed[action.payload.id] = { ...action.payload };
                }

                return newState;
            }

        case SET_ORGANIZATION_ACCOUNT:
            {
                return { ...state, organizationAccount: action.payload };
            }

        case SET_USER_LIST:
            {
                return { ...state, userList: action.payload };
            }

        case CREATE_ORGANIZATION:
            {
                return { ...state, creationState: action.payload };
            }

        case SET_CREATE_ORGANIZATION_POLLING:
            {
                return { ...state, createOrganizationPolling: action.payload };
            }

        case ADD_PIPELINE_BUILD:
            {
                const result = {
                    ...state,
                    pipelineBuilds: {
                        ...state.pipelineBuilds,
                        activeBuilds: [...state.pipelineBuilds.activeBuilds.filter(item => item.buildRequest.id !== action.payload.buildRequest.id), action.payload]
                    }
                }

                return result;
            }

        case REMOVE_PIPELINE_BUILD:
            {
                const result = {
                    ...state,
                    pipelineBuilds: {
                        ...state.pipelineBuilds,
                        activeBuilds: state.pipelineBuilds.activeBuilds.filter(item => item.buildRequest.id !== action.payload.buildRequest.id)
                    }
                }

                return result;
            }

        case SET_PIPELINE_BUILDS_STATE:
            {
                return { ...state, pipelineBuilds: action.payload };
            }

        default:
            return state;
    }
}
